import axios from 'axios';
import type { AuditLogEntry, DeviceHistoryEntry, DeviceReviewInfo, PaginatedResult, RevokeSessionsResponse } from '../types/security';

const BASE = () => import.meta.env.VITE_AUTH_API_URL;

export interface DeviceReviewResponse {
  success: boolean;
  data: DeviceReviewInfo | null;
}

export const reviewDevice = async (token: string): Promise<DeviceReviewResponse> => {
  const response = await axios.post<DeviceReviewResponse>(
    `${BASE()}/api/v1/auth/security/review-device`,
    { token },
  );
  return response.data;
};

export const confirmThisWasMe = async (token: string): Promise<{ success: boolean }> => {
  const response = await axios.post<{ success: boolean }>(
    `${BASE()}/api/v1/auth/security/this-was-me`,
    { token },
  );
  return response.data;
};

export const confirmNotMe = async (token: string): Promise<{ success: boolean }> => {
  const response = await axios.post<{ success: boolean }>(
    `${BASE()}/api/v1/auth/security/not-me`,
    { token },
  );
  return response.data;
};

export const revokeOtherSessions = async (firebaseToken: string): Promise<RevokeSessionsResponse> => {
  const response = await axios.post<{ success: boolean; data: RevokeSessionsResponse }>(
    `${BASE()}/api/v1/auth/security/revoke-sessions`,
    {},
    { headers: { Authorization: `Bearer ${firebaseToken}` } }
  );
  return response.data.data;
};

export const setPassword = async (token: string, newPassword: string): Promise<{ success: boolean }> => {
  const response = await axios.post<{ success: boolean }>(
    `${BASE()}/api/v1/auth/users/password/set-password`,
    { token, newPassword },
    { headers: { 'Content-Type': 'application/json' } }
  );
  return response.data;
};

export const getDeviceHistory = async (
  firebaseToken: string,
  page: number,
  limit: number
): Promise<PaginatedResult<DeviceHistoryEntry>> => {
  const response = await axios.get<{ success: boolean } & PaginatedResult<DeviceHistoryEntry>>(
    `${BASE()}/api/v1/auth/security/device-history`,
    {
      params: { page, limit },
      headers: { Authorization: `Bearer ${firebaseToken}` },
    }
  );
  const { data, count, page: currentPage, limit: currentLimit } = response.data;
  return { data, count, page: currentPage, limit: currentLimit };
};

export const getAuditLog = async (
  firebaseToken: string,
  page: number,
  limit: number
): Promise<PaginatedResult<AuditLogEntry>> => {
  const response = await axios.get<{ success: boolean } & PaginatedResult<AuditLogEntry>>(
    `${BASE()}/api/v1/auth/security/audit-logs`,
    {
      params: { page, limit },
      headers: { Authorization: `Bearer ${firebaseToken}` },
    }
  );
  const { data, count, page: currentPage, limit: currentLimit } = response.data;
  return { data, count, page: currentPage, limit: currentLimit };
};
